import { render, staticRenderFns } from "./QuranPrograms.vue?vue&type=template&id=22c7b383&"
import script from "./QuranPrograms.vue?vue&type=script&lang=js&"
export * from "./QuranPrograms.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports